const registry = new Map<string, (el: HTMLElement) => void>();

export function registerController(
  name: string,
  init: (el: HTMLElement) => void,
): void {
  registry.set(name, init);
}

export function scan(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>("[data-controller]").forEach((el) => {
    if (el.dataset.controllerInitialized) return;
    const name = el.dataset.controller;
    if (name && registry.has(name)) {
      registry.get(name)!(el);
      el.dataset.controllerInitialized = "true";
    }
  });
}
